import { useCallback, useEffect, useRef, useState } from 'react';
import { IonContent, IonPage, IonTitle, IonToolbar, IonText, IonItem, IonButton, IonImg, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonAlert, IonGrid, IonCol, IonRow, IonIcon, useIonViewWillEnter, useIonViewWillLeave, IonRefresher, IonRefresherContent, IonButtons, IonLabel, IonList, IonModal, useIonAlert, IonInput, IonProgressBar, IonInfiniteScroll, IonInfiniteScrollContent, IonLoading } from '@ionic/react';
import './Market.css';
import UserService from '../../services/user';
import { bagAddOutline, bagOutline, bagRemoveOutline, copy, desktopOutline, duplicateOutline, enter, filter, hammerOutline, walletOutline, warning } from 'ionicons/icons';
import { ItemNft } from '../../models/itemNft';
import { Subscription } from 'rxjs';
import Config from '../../config/settings';
import { Collections } from './Collections.enum';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Shared } from '../../shared/shared';
import { MarketEnum } from './Market.enum';
import UpdateService from '../../services/update';
import { AppVersion } from '@awesome-cordova-plugins/app-version';
import { ArweaveData } from './Arweave.interface';

const Market: React.FC<{ shared?: Shared, userService?: UserService, updateService?: UpdateService, isAndroidDevice: boolean }> = ({ shared, userService, updateService, isAndroidDevice }) => {
  const [marketData, setMarketData] = useState<ItemNft[]>();
  const [itemToBuy, setItemToBuy] = useState<ItemNft>();
  const [itemToSell, setItemToSell] = useState<ItemNft>();
  const [isClosed = false, setIsClosed] = useState<boolean>(true);
  const [filterOpened = false, setFilterOpened] = useState<boolean>();
  const [buyModaleOpened = false, setBuyModaleOpened] = useState<boolean>();
  const [isBuyingNFT, setIsBuyingNFT] = useState<boolean>(false);
  const [sellModaleOpened = false, setSellModaleOpened] = useState<boolean>();
  const [showAlertConnection, setShowAlertConnexion] = useState(false);
  const [showOutdatedVersion, setShowOutdatedVersion] = useState(false);
  const [versionTested = false, setVersionTested] = useState<boolean>();
  const [endOfItems = false, setEndOfItems] = useState<boolean>();
  const [showOwnedNFT = false, setShowNFT] = useState<boolean>();
  const [logBuying, setLogBuying] = useState<string>();
  // eslint-disable-next-line 
  const [salePrice, setSalePrice] = useState<number>(0);
  const [presentAlert] = useIonAlert();
  const [showUpdateDownload, setShowUpdateDownload] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);

  const modal = useRef<HTMLIonModalElement>(null);
  const modalBuy = useRef<HTMLIonModalElement>(null);
  // const modalBuying = useRef<HTMLIonModalElement>(null);
  const modalSell = useRef<HTMLIonModalElement>(null);

  let userServiceSubscribe: Subscription;

  const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;

  // const walletService: WalletService = new WalletService();
  // const connectionMainnet = new Connection(
  //   Config.mainnetConstantK,
  //   'confirmed',
  // );
  // const decimals = 1000000000;

  // let hasEnoughNSA: {value: boolean, total: number} = null;

  useEffect(() => {
    
    const timeout = loadMore();
    
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, []);

  // Action lors du bouton BACK
  var backButton = function() {
    var handler = function(ev: any) {
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
    };
    return handler;
  };
  
  // Dans le useState pour qu'ils soient appellés une seule fois
  useIonViewWillEnter(async () => {

    document.addEventListener('ionBackButton', backButton, false);

    // Attente du chargement du user service
    userServiceSubscribe = userService.storageInitSubject.subscribe(async (result) => {
      if (result === true) {

        // Si les données sont déjà présentes skip le chargement
        if (userService.marketCalled !== true) {
          // Si premier affichage, on charge les données
          if (userService.email && userService.email.length > 0 && userService.security && userService.security.length > 0) {
            // Vérification de la version
            checkVersion(userService.email).then(async (isOutDated) => {

              if (!isOutDated && isOutDated === false) {
                // Récupération des données pour le premier affichage
                const collection = await userService.getCollection();
                getNftData(false, collection);
              } else if (isOutDated === null) {
                // Si internet ne fonctionne pas
                setShowAlertConnexion(true);
              } else if (isOutDated === true) {
                // Si la version est trop vieille
                setShowOutdatedVersion(true);
              }
            });
                    
            // Check and update
            if (await AppVersion?.getVersionNumber().then(() => true).catch(() => false)) {
              setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
            }
            //test
            setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
          }
        }
      }
    });
  });

  useIonViewWillLeave(() => {
    // Suppression de la souscription
    if (userServiceSubscribe) {
      userServiceSubscribe.unsubscribe();
    }
  });

  const loadNextPage = (ev: any) => {

    if (!endOfItems) {
      setTimeout(async () => {

        userService.resetMarketCalled();

        const collection = await userService.getCollection();

        getNftData(false, collection);
        
        if (ev) ev.target.complete();

      }, 300);
    }
  }

  function handleRefresh(event?: CustomEvent<any>) {

    setEndOfItems(false);
    
    setTimeout(async () => {
      
      userService.resetIsMarketPage();
      
      // Reset des données chargées
      setMarketData([]);
      userService.clearMarketData();
      userService.resetMarketCalled();

      // Rechargement des données
      const collection = await userService.getCollection();
      getNftData(true, collection);

      if (event) {
        event.detail.complete();
      }
    }, 2000);
  }

  const loadMore = useCallback(() => {
    return setTimeout(() => {
      loadNextPage(null);
    }, 200)
    // eslint-disable-next-line
  }, [setMarketData]);

  /**
   * Vérification de la version de l'application
   * @param email 
   */
  async function checkVersion(email: any) {

    if (email && !versionTested) {
      setVersionTested(true);

      return userService.checkVersion(email)
        .then((result: boolean) => {
          setShowOutdatedVersion(result);
          return result;
        }
      );
    }
  }

  /**
   * Sauvegarde état walllet ayant assez de NSA pour conclure une transaction
   * @param value boolean du resultat si le wallet contient assez de NSA 
   */
  // function setHasEnoughNSA(value: boolean, total: number) {
  //   hasEnoughNSA = {value: value, total: total};
  // }
  
  /**
   * Récupérer les données des NFT
   */
  async function getNftData(refresh: boolean = false, collection: number, reload: boolean = false) {

    if (refresh) {
      // On vide la liste des NFT
      setMarketData([]);
      userService.clearMarketData();
      userService.resetIsMarketPage();
      setEndOfItems(false);
      // On cache la page mes NFT
      setShowNFT(false);
    }

    if (userService && userService.email && userService.security && (refresh) ? refresh : !userService.marketCalled && !endOfItems) {
      
      userService.setMarketCalled();
      
      const url = baseUrl + 'market?email=' + userService.email + '&security=' + userService.security + '&page=' + userService.isMarketPage + '&collection=' + collection + '&v=' + Config.version;

      await fetch(url, { signal: AbortSignal.timeout(5000) }).then(
        async (res) => {
          
          const result = await res.json();
          
          const newData: ItemNft[] = [];
          const max = userService.getMarketData().length + 50;
          const min = max - 10;

          // console.log('market:', result);
          
          if (result && result.msg && result.msg.indexOf('closed') > 0) {
            // Blocage marché fermé 
            setIsClosed(true);

            for (let i = min; i < max; i++) {
              newData.push({
                id: i,
                img: '',
                title: '',
                collection: null,
                description: '',
                date: new Date(),
                contract: '',
                price: ''
              });
            }

            // Ajout des données à l'infinite scroll
            userService.setMarketData(
              newData
              );

            setMarketData(newData);
          } else if (result && result.msg && result.msg.indexOf('email') > 0) {
            // Blocage email non confirmé
            setIsClosed(true);
            
            alert('Please confirm your email to access marketplace');

            for (let i = min; i < max; i++) {
              newData.push({
                id: i,
                img: '',
                title: '',
                collection: null,
                description: '',
                date: new Date(),
                contract: '',
                price: ''
              });
            }

            // Ajout des données à l'infinite scroll
            userService.setMarketData(
              newData
            );

            setMarketData(newData);

          } else {
            // Actif et marché ouvert
            setIsClosed(false);
            
            // On vide la liste si c'est le 1er chargement
            if (userService.isMarketPage === 0) {
              userService.clearMarketData();
            }
            
            // On incrémente la page
            userService.incrementMarketPage();
            
            if (result.length === 0 && !reload) {
              setEndOfItems(true);
            } else {
              // const img_path_prefix = 'https://nebula-webapp.spl-token.com/assets/nft/';

              for (const element of result) {

                const collectionName: Collections = shared.getCollectionName(element.collection);

                newData.push({
                  id: (element.id) ? element.id : null,
                  img: (element.img_url) ? await getPictureArweave(element.img_url) : null,
                  title: (element.title) ? element.title : null,
                  collection: collectionName,
                  description: (element.description) ? element.description : null,
                  date: (element.date) ? element.date : null,
                  contract: (element.contract) ? element.contract : null,
                  price: (element.price) ? element.price : null,
                });
              }

              // Ajout des données à l'infinite scroll
              userService.setMarketData([
                ...userService.getMarketData(),
                ...newData
              ]);

              setMarketData([
                ...userService.getMarketData(),
                ...newData
              ]);
            }
          }
        }
      ).catch((_e) => {
        console.log('error getNftData', _e);
        setShowAlertConnexion(true);
      }).finally(() => {
        // setIsLoadingNftdata(false);
      });
    }
  }

  async function getPictureArweave(arweaveMetadataUrl) {
    return await fetch(arweaveMetadataUrl).then(async result => {
      const resultJson: ArweaveData = await result.json()
      return resultJson.image;
    });
  }

  /**
   * Ferme l'application dépréciée
   */
  function closeOutdatedVersion() {
    setShowOutdatedVersion(false);
    userService.forceCloseApp();
  }

  /**
   * Explorer le contrat
   * @param contract le numéro de contrat
   */
  function exploreContract(contract: string) {
    const contract_prefix = 'https://solscan.io/token/';
    window.open(contract_prefix + contract, '_blank');
  }

  /**
   * Ouvrir la page d'achat du contrat
   * @param contract numéro de contrat
   */
  function openBuyContract(item: ItemNft) {
    setItemToBuy(item);
    setBuyModaleOpened(true);
  }

  /**
   * Ouvrir la page d'achat du contrat
   * @param contract numéro de contrat
   */
  function openSellContract(item: ItemNft) {
    setItemToSell(item);
    setSellModaleOpened(true);
  }

  /**
   * Acheter le NFT
   * @param item données du NFT
   */
  async function buyNFT(item: ItemNft) {

    // Loader achat
    setIsBuyingNFT(true);
    setLogBuying('Buying NFT ' + item.title + ', please be patient it can take some time.');

    // On check si le market est ouvert
    setLogBuying('Checking if the market place buy/sale is active');

    const url = baseUrl + 'market_open_buy_sell?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
    await fetch(url).then(
    async (res) => {
      const result = await res.json();

      // Marché ouvert
      if (result?.msg === true) {

        // Récupération valeur de NSA dans le wallet in-app
        const url = baseUrl + 'get-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
        await fetch(url).then(
          async (res) => {
            const result = await res.json();

            // Montant du NFT
            const nftPrice = Number(item.price);
            // Taxe sur le prix 2%
            const nftPriceTax = Number(item.price) / 100 * 2;
            // Nombre NSA dans in-app wallet
            const nsaAmount = Number(result.msg.nsa) ?? 0;
            // Calcul si l'utilisateur possède assez de nsa pour acheter
            const hasEnoughNSA = (nftPrice + nftPriceTax) <= nsaAmount;

            // Possède assez de NSA, donc achat du NFT
            if (hasEnoughNSA) {
                    
              // Check si le nft n'est pas en cours d'achat, on l'achète
              const url = baseUrl + 'market_check_item?email=' + userService.email + '&security=' + userService.security + '&contract=' + item.contract + '&v=' + Config.version;
              await fetch(url).then(
                async (itemIsLock) => {

                  // SI nft pas locké, on lock et on achète
                  const itemIsLockResult = await itemIsLock.json();
                  if (itemIsLockResult?.msg?.locked === false) {
      
                    // console.log('locked', itemIsLockResult);
      
                    const url = baseUrl + 'market_buy_item?email=' + userService.email + '&security=' + userService.security + '&contract=' + item.contract + '&v=' + Config.version;
                            
                    fetch(url).then(
                      async (buyItem) => {
                        const buyItemResult = await buyItem.json();
      
                        setIsBuyingNFT(false);
      
                        if (buyItemResult?.msg === true) {
                          presentAlert({
                            header: 'Message',
                            subHeader: '',
                            message: 'This item is now yours and available in "MY NFT"',
                            buttons: [
                              // {
                              //   text: 'Open',
                              //   role: 'open',
                              //   handler: () => {
                              //     window.open(`https://solscan.io/tx/${signature}`)
                              //   },
                              // },
                              {
                                text: 'Quit',
                                role: 'quit',
                                handler: () => {
                                  console.log('Buying NFT done');
                                },
                              } 
                            ],
                          });
      
                          handleRefresh();
                        }
                      }
                    )
                    
                    // if (itemLockingResult?.msg?.locked === true) {
                
                    //   const seedkey = await userService.getSeedkey();
                    //   const pubkey = await userService.getPubkey();
                    //   const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
                    //   const keypair = Keypair.fromSeed(seedBip39.slice(0, 32));
                      
                    //   // // receiver est le wallet du projet qui a tous les NFT en vente
                    //   const receiver = new PublicKey(Accounts.nsa);
      
                    //   // Transférer les nsa tokens au wallet du projet
                    //   // https://stackoverflow.com/questions/68236211/how-to-transfer-custom-token-by-solana-web3-js
                      
                    //   setLogBuying('Sending your NSA transaction');
      
                    //   (async () => {
      
                    //     const totalPrice = item.price;
      
                    //     const nsaToken = new PublicKey(Config.tokenAddress);
                    //     console.log('nsaToken', nsaToken);
      
                    //     const tokenToTransfer = new Token(
                    //       connectionMainnet,
                    //       nsaToken,
                    //       TOKEN_PROGRAM_ID,
                    //       keypair
                    //     );
                    //     console.log('myToken', tokenToTransfer);
      
                    //     // Create associated token accounts for my token if they don't exist yet
                    //     const fromTokenAccount = await tokenToTransfer.getOrCreateAssociatedAccountInfo(
                    //       keypair.publicKey
                    //     );
                        
                    //     const toTokenAccount = await tokenToTransfer.getOrCreateAssociatedAccountInfo(
                    //       receiver
                    //     );
      
                    //     const modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
                    //       units: 2200000
                    //     });
          
                    //     const addPriorityFee = ComputeBudgetProgram.setComputeUnitPrice({
                    //       microLamports: 130000
                    //     });
      
                    //     const recentBlockhash = await connectionMainnet.getLatestBlockhash();
      
                    //     // Add token transfer instructions to transaction
                    //     const transaction = new Transaction({
                    //       recentBlockhash: recentBlockhash.blockhash,
                    //     })
                    //     .add(modifyComputeUnits)
                    //     .add(addPriorityFee)
                    //     .add(
                    //       Token.createTransferInstruction(
                    //         TOKEN_PROGRAM_ID,
                    //         fromTokenAccount.address,
                    //         toTokenAccount.address,
                    //         keypair.publicKey,
                    //         [],
                    //         Number(totalPrice) * decimals
                    //       )
                    //     );
                    //     transaction.feePayer = keypair.publicKey;
      
                    //     console.log('transaction', transaction);
      
                    //     setLogBuying('Waiting for confirmations, it can take some time...');
      
                    //     // https://www.quicknode.com/guides/solana-development/spl-tokens/how-to-transfer-spl-tokens-on-solana
                    //     const latestBlockHash = await connectionMainnet.getLatestBlockhash('confirmed');
                    //     transaction.recentBlockhash = await latestBlockHash.blockhash; 
                        
                    //     try {
                    //       const signature = await sendAndConfirmTransaction(
                    //         connectionMainnet,
                    //         transaction,
                    //         [keypair],
                    //         {
                    //           skipPreflight: true,
                    //           maxRetries: 0
                    //         }
                    //       );
      
                    //       if (signature && signature.length > 0) {
                    //         console.log(
                    //           '\x1b[32m', //Green Text
                    //           `   Transaction Success!🎉`,
                    //           `\n    https://solscan.io/tx//${signature}`
                    //         );
                    //         setLogBuying('Transmit transaction signature to server');
                            
                    //         const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
                    //         const url = baseUrl + 'market_buy_item?email=' + userService.email + '&security=' + userService.security + '&contract=' + item.contract + '&signature=' + signature + '&v=' + Config.version;
                            
                    //         fetch(url).then(
                    //           async (buyItem) => {
                    //             const buyItemResult = await buyItem.json();
      
                    //             setIsBuyingNFT(false);
      
                    //             setTransactionUrl(`https://solscan.io/tx/${signature}`)
                                
                    //             if (buyItemResult?.msg === true) {
                    //               presentAlert({
                    //                 header: 'Message',
                    //                 subHeader: '',
                    //                 message: 'This item is now yours and available in "MY NFT"',
                    //                 buttons: [
                    //                   {
                    //                     text: 'Open',
                    //                     role: 'open',
                    //                     handler: () => {
                    //                       window.open(`https://solscan.io/tx/${signature}`)
                    //                     },
                    //                   },
                    //                   {
                    //                     text: 'Quit',
                    //                     role: 'quit',
                    //                     handler: () => {
                    //                       console.log('Buying NFT done');
                    //                     },
                    //                   } 
                    //                 ],
                    //               });
      
                    //               handleRefresh();
                    //             }
                    //           }
                    //         );
                    //       } else {
                    //         console.log('Signature failed');
                    //         // transactionFailed(item);
                    //       }
                    //     } catch(error) {
                    //       transactionFailed(item);
                    //     }
                    //   })();
                    // }
                  } else if (itemIsLockResult?.msg?.locked === true) {
                      setIsBuyingNFT(false);
                      presentAlert({
                        header: 'Message',
                        subHeader: '',
                        message: 'This item is currently locked because a user try to buy it. If his transaction fail, the item will be unlocked. Please try to buy again later.',
                        buttons: ['OK'],
                      });
                  } else if (itemIsLockResult?.msg?.selling === false) {
                    setIsBuyingNFT(false);
                    presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: 'This item is not for sale.',
                      buttons: ['OK'],
                    });
                  } else {
                    setIsBuyingNFT(false);
                    presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: 'The service return error, please contact support.',
                      buttons: ['OK'],
                    });
                  }
                }
              );
            } else {
              setIsBuyingNFT(false);
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: `You have not enough NSA in your in-app wallet, to pay transaction and service fees for this item.`,
                buttons: ['OK'],
              });
            }
        })
      } else {
        setIsBuyingNFT(false);
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Buying items on the market is currently disabled by the server.',
          buttons: ['OK'],
        });
      }
    }).catch((_e) => {
      setIsBuyingNFT(false);
      setShowAlertConnexion(true);
    });
  }

  /**
   * Acheter le NFT
   * @param item données du NFT
   */
  async function sellNFT(item: ItemNft) {
    
    presentAlert({
      header: 'Message',
      subHeader: '',
      message: `Selling NFT is coming soon`,
      buttons: ['OK'],
    });

    // // Montant du NFT
    // const amountRequiredToByNFT = Number(item.price);
    
    // // Vérifier si le wallet contient assez de NSA
    // await getNsaTokenAccountsByOwner(amountRequiredToByNFT).then(() => {
    //   if (!hasEnoughNSA.value) {
    //     presentAlert({
    //       header: 'Message',
    //       subHeader: '',
    //       message: `You have not enough NSA in your wallet (${hasEnoughNSA.total}), you need a minimum of ${item.price} to buy the NFT #${item.title} of ${item.collection} collection.`,
    //       buttons: ['OK'],
    //     });
    //   }
    // });
    
    // // Vérifier si le wallet contient assez de SOL
    // if (hasEnoughNSA.value) {
    //   const seedkey = await userService.getSeedkey();
    //   const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
    //   const keypair = Keypair.fromSeed(seedBip39.slice(0, 32));

    //   const blockchainFees = await shared.calculateFeeTransfer(keypair);

    //   console.log('blockchainFees', blockchainFees);

    //   // TODO: calculer le prix en SOL du NFT et calculer le fees du service
    //   const serviceFees = 0.0002;
    //   const totalFees = blockchainFees + serviceFees;

    //   console.log('totalFees', totalFees);

    //   await getSolanaBalance(totalFees);

    //   console.log('next sol balance', hasEnoughSOL);

    //   if (!hasEnoughSOL.value) {
    //     presentAlert({
    //       header: 'Message',
    //       subHeader: '',
    //       message: `You have not enough SOL in your wallet (${hasEnoughSOL.total}), you need a minimum of ${item.price} for the transaction and service fees.`,
    //       buttons: ['OK'],
    //     });
    //   } else {
    //     // TODO: faire la transaction d'achat
    //     // presentAlert({
    //     //   header: 'Message',
    //     //   subHeader: '',
    //     //   message: `You have enough NSA (${hasEnoughNSA.total}) and SOL (${hasEnoughSOL.total}) in your wallet, but the service is currently disabled.`,
    //     //   buttons: ['OK'],
    //     // });

    //     const seedkey = await userService.getSeedkey();
    //     const pubkey = await userService.getPubkey();
    //     const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
    //     const keypair = Keypair.fromSeed(seedBip39.slice(0, 32));
        
    //     // receiver est le wallet du projet qui a tous les NFT en vente
    //     const receiver = new PublicKey(Accounts.nsa);

    //     // Transférer les nsa tokens au wallet du projet
    //     // https://stackoverflow.com/questions/68236211/how-to-transfer-custom-token-by-solana-web3-js
        
    //     (async () => {

    //       setIsLoadingNftdata(true);

    //       const totalPrice = item.price;

    //       const nsaToken = new PublicKey(Config.tokenAddress);
    //       console.log('nsaToken', nsaToken);

    //       const tokenToTransfer = new Token(
    //         connectionMainnet,
    //         nsaToken,
    //         TOKEN_PROGRAM_ID,
    //         keypair
    //       );
    //       console.log('myToken', tokenToTransfer);

    //       // Create associated token accounts for my token if they don't exist yet
    //       const fromTokenAccount = await tokenToTransfer.getOrCreateAssociatedAccountInfo(
    //         keypair.publicKey
    //       );
    //       console.log('fromTokenAccount', fromTokenAccount);
          
    //       const toTokenAccount = await tokenToTransfer.getOrCreateAssociatedAccountInfo(
    //         receiver
    //       );
    //       console.log('fromTokenAccount', fromTokenAccount);

    //       // Add token transfer instructions to transaction
    //       const transaction = new Transaction()
    //         .add(
    //           Token.createTransferInstruction(
    //             TOKEN_PROGRAM_ID,
    //             fromTokenAccount.address,
    //             toTokenAccount.address,
    //             keypair.publicKey,
    //             [],
    //             Number(totalPrice)
    //           )
    //         );
    //         console.log('transaction', transaction);

    //       // Sign transaction, broadcast, and confirm
    //       const signature = await sendAndConfirmTransaction(
    //         connectionMainnet,
    //         transaction,
    //         [keypair]
    //       );

    //       if (signature) {
    //         console.log('signature', signature);
    //         await sendTransactionAddressToNFTService(signature, item.contract);
    //       }

    //       setIsLoadingNftdata(false);
    //     })();
    //   }
    // }
  }

  /**
   * Upgrader le contrat
   * @param contract numéro de contrat
   */
  function upgradeContract(contract: string) {
    presentAlert({
      header: 'Message',
      subHeader: '',
      message: 'Upgrading NFT will be available soon: ' + contract,
      buttons: ['OK'],
    });
  }

  function repairContract(contract: string) {
    presentAlert({
      header: 'Message',
      subHeader: '',
      message: 'Repair NFT will be available soon: ' + contract,
      buttons: ['OK'],
    });
  }

  /**
   * Charger les NFT d'une classe spécifique
   * @param classNum 
   */
  async function loadClass(classNum: number) { 
    userService.setCollection(classNum).then(async () => {
      const collection = await userService.getCollection();   
      getNftData(true, collection);
      dismissFilterModal();
    });
  }

  /**
   * Fermer la popin de filtres
   */
  function dismissFilterModal() {
    // modal.current?.dismiss();
    setFilterOpened(false);
  }

  /**
   * Fermer la popin d'achat de NFT'
   */
  function dismissModal(modal: string) {
    // modalBuy.current?.dismiss();
    
    switch (modal) {
      case 'buy':
        setBuyModaleOpened(false);
        break;

      case 'sell':
        setSellModaleOpened(false);        
        break;
    }
  }

  /**
   * Afficher les NFT possédés
   * @param show 
   */
  async function showMyNFT(show: boolean) {

    if (show) {

      setShowNFT(true);

      // On vide la liste des NFT
      setMarketData([]);
      userService.setMarketData([]);

      // On charge la liste des nft possédés
      const url = baseUrl + 'market_items?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      await fetch(url).then(
        async (item) => {
          
          const resultItem: ItemNft[] = await item.json();

          if (resultItem && resultItem.length > 0) {

            const listMyNFT: ItemNft[] = [];
            
            for (const element of resultItem) {

              const collectionName: Collections = shared.getCollectionName(element.collection.toString());
              
              listMyNFT.push({
                id: (element.id) ? element.id : null,
                img: (element.img) ? await getPictureArweave(element.img) : null,
                title: (element.title) ? element.title : null,
                collection: collectionName,
                description: (element.description) ? element.description : null,
                date: (element.date) ? element.date : null,
                contract: (element.contract) ? element.contract : null,
                price: (element.price) ? element.price : null,
              })
              // console.log('item');
            };

            // console.log('list my NFT', listMyNFT, resultItem);

            // Ajout des données à l'infinite scroll
            userService.setMarketData(listMyNFT);
            setMarketData(listMyNFT);
          }
        }
      ).catch(() => {
        setShowAlertConnexion(true);
      });
    }
  }

  /**
   * Ouvre la page de presale
   */
  function gotoWallet() {
    const page = 'wallet';
    const presaleTab: HTMLElement | null = document.querySelector('#tab-button-' + page);
    presaleTab?.click();
  }
  
  return (
    <IonPage>

      { showAlertConnection &&
          <div className="no-connection">
            <span>
              <h1>Please check your internet connection.</h1>
              <p>If your connection is working, it is likely that the servers are under maintenance.</p>
              <p>Please visit the support channels for information.</p>
              <h2>Your wallet remains usable during maintenance.</h2>
              <IonButton color="secondary" style={{ height: "52px" }} onClick={() => gotoWallet()}><IonIcon icon={enter} style={{ paddingRight: "5px" }}></IonIcon> Wallet</IonButton>
            </span>
          </div>
      }

      <IonContent id="container-market" className="container-market">

        <IonRefresher slot="fixed" closeDuration={'1000ms'} onIonRefresh={handleRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        { showUpdateDownload &&
          <div style={{zIndex: 9999, position: 'fixed', marginTop: '150px', marginLeft: 'calc(50% - 232.3px / 2)', background: 'black', display: 'flex', flexDirection: 'column', borderRadius: '15px', padding: '15px'}}>
            <h1 style={{marginTop: 0}}>Info</h1>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>An update is available.</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>Your current version is: {updateService.versionInstalled}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>The latest version is: {updateService.versionServer}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}><b>Proceed to the update ?</b></p>
            <div style={{textAlign: 'right', paddingTop: '.7rem'}}>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px'}} onClick={() => setShowUpdateDownload(false)}>No</button>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px', marginLeft: '5px', background: 'rgb(133,231,133)', color: 'black'}} onClick={() => {setShowDownload(true); updateService.updateApplication(userService)}}>Yes</button>
            </div>
          </div>
        }
        <IonLoading message="Downloading update please wait... ~15mb" isOpen={showDownload}></IonLoading>

        {/* Popin de chargement de données */}
        {
          isBuyingNFT &&
          <IonLoading
            cssClass='my-custom-class'
            isOpen={isBuyingNFT}
            message={logBuying}
            duration={0}
            spinner={'dots'}
          />
        }
  
        {/* Message d'alerte dans le cas d'une ancienne version */}
        <IonAlert
          isOpen={showOutdatedVersion}
          onDidDismiss={() => closeOutdatedVersion()}
          cssClass='my-custom-class'
          header={'Alert'}
          subHeader={'Your application version is OUTDATED'}
          message={'Please upgrade the application from PlayStore, thanks.'}
          buttons={['Exit']}
        />

        {/* Barre de filtres */}
        <IonGrid className="filter-bar">
          <IonRow>
            <IonCol size="2">
              <IonImg className="filter-bar-img" src="/assets/icon/new_icon.png" />
            </IonCol>
            <IonCol size="8" className="full-scroll">
              <IonRow style={{ height: '60px'}}>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-nft" className={showOwnedNFT ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => showMyNFT(true)
                  }>My NFT <IonIcon icon={walletOutline} slot="end"></IonIcon>
                  </IonButton>
                </IonCol>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-sales"className={!showOwnedNFT ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => { 
                      userService.setCollection(0).then(
                        async () => {
                          const collection = await userService.getCollection(); 
                          getNftData(true, collection, true);
                        }
                      ) 
                    }
                  }>Market <IonIcon icon={bagOutline} slot="end"></IonIcon></IonButton>
                </IonCol>
              </IonRow>
            </IonCol>
            <IonCol size="2">
              <IonButton id="open-filter" color="secondary" style={{ height: '52px', width: '100%' }} onClick={() => setFilterOpened(true)}><IonIcon icon={filter}></IonIcon></IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>

        {/* Filtres modale */}
        <IonModal id="filter-modal" ref={modal} isOpen={filterOpened} onDidDismiss={() => setFilterOpened(false)}>
          <IonContent>
            <IonToolbar>
              <IonTitle>Filter specific class</IonTitle>
              <IonButtons slot="end">
                <IonButton color="light" onClick={() => dismissFilterModal()}>
                  Close
                </IonButton>
              </IonButtons>
            </IonToolbar>
            <IonList>
              <IonItem onClick={() => {
                userService.setCollection(1).then(async () => {
                  const collection = await userService.getCollection();
                  loadClass(collection);
                });}}>
                <IonLabel>
                  <h2>Class 1</h2>
                  <p>Wooden pen</p>
                </IonLabel>
              </IonItem>
              <IonItem onClick={() => {
                userService.setCollection(2).then(async () => {
                  const collection = await userService.getCollection();
                  loadClass(collection);
                });}}>
                <IonLabel>
                  <h2>Class 2</h2>
                  <p>Ballpoint pencil</p>
                </IonLabel>
              </IonItem>
              <IonItem onClick={() => {
                userService.setCollection(3).then(async () => {
                  const collection = await userService.getCollection();
                  loadClass(collection);
                });}}>
                <IonLabel>
                  <h2>Class 3</h2>
                  <p>Feather pencil</p>
                </IonLabel>
              </IonItem>
            </IonList>
          </IonContent>
        </IonModal>

        {/* Acheter NFT modale */}
        <IonModal id="filter-buy-modal" ref={modalBuy} isOpen={buyModaleOpened} onDidDismiss={() => setBuyModaleOpened(false)}>
          <IonContent>
            <IonToolbar>
              <IonTitle>Buy NFT</IonTitle>
              <IonButtons slot="end">
                <IonButton color="light" onClick={() => dismissModal(MarketEnum.BUY)}>
                  Close
                </IonButton>
              </IonButtons>
            </IonToolbar>
            <IonList>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Name</h2>
                        <p>#{itemToBuy?.title}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Class</h2>
                        <p>{itemToBuy?.collection}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Current price</h2>
                        <p>{itemToBuy?.price}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Upgrades</h2>
                        {/* <p>0</p> */}
                        <p>Locked</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonItem>
                <IonLabel>
                  <img className="nft-illustration" src={itemToBuy?.img} alt="nft-illustration" />
                </IonLabel>
              </IonItem>
              <IonGrid>
                <IonRow>
                  <IonCol size="6">
                    <IonButton className="full-size" onClick={() => buyNFT(itemToBuy)}><IonIcon className="icon-icon-list" icon={bagAddOutline} slot="start" /> Buy</IonButton>
                  </IonCol>
                  <IonCol size="6">
                    <IonButton className="full-size" onClick={() => exploreContract(itemToBuy?.contract)}><IonIcon className="icon-icon-list" icon={desktopOutline} slot="start" /> Explore</IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonItem>
                <IonLabel className="no-margin">
                  <h2>Token Address</h2>
                  <p><CopyToClipboard text={itemToBuy?.contract}>
                  <IonIcon className="icon-icon-list" icon={copy} onClick={
                    () => { presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: `NFT address "${itemToBuy?.contract}" was saved to clipboard`,
                      buttons: ['OK'],
                    }) }
                    } /></CopyToClipboard> {itemToBuy?.contract}</p>
                </IonLabel>
              </IonItem>
            </IonList>
          </IonContent>
        </IonModal>

        {/* Vendre NFT modale */}
        <IonModal id="filter-buy-modal" ref={modalSell} isOpen={sellModaleOpened} onDidDismiss={() => setSellModaleOpened(false)}>
          <IonContent>
            <IonToolbar>
              <IonTitle>Sell the NFT</IonTitle>
              <IonButtons slot="end">
                <IonButton color="light" onClick={() => dismissModal(MarketEnum.SELL)}>
                  Close
                </IonButton>
              </IonButtons>
            </IonToolbar>
            <IonList>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Name</h2>
                        <p>#{itemToSell?.title}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Class</h2>
                        <p>{itemToSell?.collection}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Current price</h2>
                        <p>{itemToSell?.price} NSA</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2>Upgrades</h2>
                        <p>0</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="no-margin">
                        <h2><IonIcon className="icon-icon-list" icon={warning}/> SALE PRICE</h2>
                        <p className="full-text">Putting your NFT up for sale will block it for sale for a period of 24 hours. Only at the end of this period will you be able to cancel the sale.</p>
                      </IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid className="no-margin">
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonInput type="number" min={100} max={100000000} placeholder="10000" onIonChange={salePrice => setSalePrice(Number(salePrice.detail.value))}></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonItem>
                <IonLabel>
                  <img className="nft-illustration" src={itemToSell?.img} alt="nft-illustration" />
                </IonLabel>
              </IonItem>
              <IonGrid>
                <IonRow>
                  <IonCol size="6">
                    <IonButton className="full-size" onClick={() => sellNFT(itemToSell)}><IonIcon className="icon-icon-list" icon={bagRemoveOutline} slot="start" /> Sell</IonButton>
                  </IonCol>
                  <IonCol size="6">
                    <IonButton className="full-size" onClick={() => exploreContract(itemToSell?.contract)}><IonIcon className="icon-icon-list" icon={desktopOutline} slot="start" /> Explore</IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonItem>
                <IonLabel className="no-margin">
                  <h2>Token Address</h2>
                  <p><CopyToClipboard text={itemToSell?.contract}>
                  <IonIcon className="icon-icon-list" icon={copy} onClick={
                    () => { presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: `NFT address "${itemToSell?.contract}" was saved to clipboard`,
                      buttons: ['OK'],
                    }) }
                    } /></CopyToClipboard> {itemToSell?.contract}</p>
                </IonLabel>
              </IonItem>
            </IonList>
          </IonContent>
        </IonModal>

        <IonGrid style={{ height: 'calc(100% - 78px)', marginTop: '78px' }}>
          <IonRow>
            {/* Liste des NFT (ALL) */}
            {!isClosed && !showOwnedNFT && marketData?.length > 0 && marketData?.map((item, index) => (
              <IonCol size="6" key={`${item.id}_${index}`}>
                <IonItem className="nft-item">
                  <IonCard className="card-item">
                          
                    <img src={item.img} alt="nft-illustration" />
                          
                    <IonCardHeader className="card-header text">
                      <IonCardTitle className="card-title" title='NFT title'>#{item.title}</IonCardTitle>
                      <IonCardSubtitle className="card-subtitle" title='NFT collection'><strong>{item.collection}</strong></IonCardSubtitle>
                    </IonCardHeader>

                    <IonCardContent className="card-price" title='NFT price'>
                      <IonRow>
                        <IonCol>{item.price} NSA</IonCol>
                      </IonRow>
                    </IonCardContent>

                    <IonCardContent className="card-upgrades ion-text-left" title='NFT upgrade'>
                      <IonRow>
                        <IonCol><span>Level</span> {0}</IonCol>
                        <IonCol>
                          <IonLabel>HP - 100%</IonLabel>
                          <IonProgressBar value={1} buffer={0}></IonProgressBar>
                        </IonCol>
                      </IonRow>
                    </IonCardContent>

                    <IonCardContent className="card-attributes ion-text-left" title='NFT attributes'>
                      <IonRow>
                        <IonCol className="ion-text-nowrap">{0} <span>Maniab.</span></IonCol>
                        <IonCol className="ion-text-nowrap">{0} <span>Luck</span></IonCol>
                        <IonCol className="ion-text-nowrap">{0} <span>Durab.</span></IonCol>
                      </IonRow>
                    </IonCardContent>
                          
                    <IonRow className="card-buttons">
                      <IonCol>
                        <IonButton onClick={() => openBuyContract(item)}><IonIcon className="icon-icon-list" icon={bagAddOutline} slot="start" /> Buy</IonButton>
                      </IonCol>
                      <IonCol>
                        <IonButton onClick={() => exploreContract(item.contract)}><IonIcon className="icon-icon-list" icon={desktopOutline} slot="start" /> Explore</IonButton>
                      </IonCol>
                    </IonRow>

                  </IonCard>
                </IonItem>
              </IonCol>
              ))
            }

            {/* Liste des NFT (OWNED) */}
            {!isClosed && showOwnedNFT && marketData?.length > 0 && marketData?.map((item, index) => (
              <IonCol size="6" key={`${item.id}_${index}`}>
                <IonItem className="nft-item">
                  <IonCard className="card-item">
                    
                    <img src={item.img} alt="nft-illustration" />
                    
                    <IonCardHeader className="card-header text">
                      <IonCardTitle className="card-title" title='NFT title'>#{item.title}</IonCardTitle>
                      <IonCardSubtitle className="card-subtitle" title='NFT collection'><strong>{item.collection}</strong></IonCardSubtitle>
                    </IonCardHeader>

                    <IonCardContent className="card-price" title='NFT price'>
                      {item.price} NSA
                    </IonCardContent>

                    <IonCardContent className="card-upgrades ion-text-left" title='NFT upgrade'>
                      <IonRow>
                        <IonCol><span>Level</span> {0}</IonCol>
                        <IonCol>
                          <IonLabel>HP - 100%</IonLabel>
                          <IonProgressBar value={1} buffer={0}></IonProgressBar>
                        </IonCol>
                      </IonRow>
                    </IonCardContent>

                    <IonCardContent className="card-attributes ion-text-left" title='NFT attributes'>
                      <IonRow>
                        <IonCol>{0} <span>Maniab.</span></IonCol>
                        <IonCol>{0} <span>Luck</span></IonCol>
                        <IonCol>{0} <span>Durab.</span></IonCol>
                      </IonRow>
                    </IonCardContent>
                    
                    <IonRow className="card-buttons">
                      <IonCol>
                        <IonButton onClick={() => openSellContract(item)}><IonIcon className="icon-icon-list" icon={bagRemoveOutline} slot="start" /> Sell</IonButton>
                      </IonCol>
                      <IonCol>
                        <IonButton onClick={() => exploreContract(item.contract)}><IonIcon className="icon-icon-list" icon={desktopOutline} slot="start" /> Explore</IonButton>
                      </IonCol>
                    </IonRow>
                    
                    <IonRow className="card-buttons">
                      <IonCol>
                        <IonButton onClick={() => upgradeContract(item.contract)}><IonIcon className="icon-icon-list" icon={duplicateOutline} slot="start" /> Upgrade</IonButton>
                      </IonCol>
                      <IonCol>
                        <IonButton onClick={() => repairContract(item.contract)}><IonIcon className="icon-icon-list" icon={hammerOutline} slot="start" /> Repair</IonButton>
                      </IonCol>
                    </IonRow>

                  </IonCard>
                </IonItem>
              </IonCol>
              ))
            }
          </IonRow>
          {!isClosed && !showOwnedNFT &&
            <IonInfiniteScroll
              onIonInfinite={(ev) => {
                loadMore();
                setTimeout(() => ev.target.complete(), 500);
              }}
            >
              <IonInfiniteScrollContent loadingSpinner="crescent"></IonInfiniteScrollContent>
            </IonInfiniteScroll>
          }
        </IonGrid>
        


        {/* Message information marché fermé */}
        { isClosed &&
          <div className="container-market-alert">
            <IonImg style={{ margin: "auto", height: "52px", width: "52px"}} src="/assets/icon/new_icon.png" />
            <IonText>The NFT Marketplace is currently loading. If the message persists, the Marketplace is temporarily under maintenance. Please refer to the announcement channel for more information. Thank you for your patience.</IonText>
          </div>
        }

      </IonContent>
    </IonPage>
  );
};

export default Market;